module.exports = __webpack_public_path__ + "static/img/MBTI-picture1.32f7c3ad.jpg";